import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";

export interface ICareer {
  id: number
  code: string
  title: string
  status: number
}
export interface ICareerEdit {
  id: number
  code: string
  title: string
  status: number
}
// danh sách nghề nghiệp khách hàng
export const gListCareer = async (limit?: number, pageNumber?: number, search?: string) => {
  const path = "profession/listProfession"
  const params = {
    limit, pageNumber, search
  }
  const result: ResponseSuccessTotal<ICareer[]> = await axiosClient.get(
    path, { params }
  )
  return result
};

// thông tin nghề nghiệp
export const gInfoCareer = async (id: number) => {
  const path = "profession/infoProfession"
  const params = {
    id
  }
  const result: ResponseSuccessTotal<ICareerEdit> = await axiosClient.get(
    path, { params }
  )
  return result
}
//thêm nghề nghiệp
export const addCareer = async (code: string, title: string, status: number) => {
  const path = "profession/addProfession"
  const params = {
    code, title, status
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    path, params
  )
  return result
}
// chỉnh sửa nghề nghiệp
export const editCareer = async (id: number,code: string,  title: string, status: number) => {
  const path = "profession/editProfession"
  const params = {
    id, code, title, status
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}
// xóa nghề nghiệp
export const deleteCareer = async (id: number) => {
  const path = "profession/deleteProfession"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    path, { params }
  )
  return result
}
// cập nhật trạng thái nghề nghiệp
export const updateStatusCareer = async (id: number) => {
  const path = "profession/activeProfession"
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    path, params
  )
  return result
}
